<template>
  <div>
    <van-popup v-model="isShow" position="bottom" @click-overlay="onCancel">
      <van-datetime-picker v-model="currentDate" type="year-month" :formatter="formatter" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Time',
  props: ['show'],
  data() {
    return {
      isShow: this.show,
      currentDate: new Date()
    }
  },
  methods: {
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      }
      return value
    },
    onCancel() {
      this.isShow = false
      this.$emit('cancel', this.isShow)
    },
    onConfirm(value) {
      this.isShow = false
      this.$emit('cancel', this.isShow)
      this.$emit('change', value)
    }
  }
}
</script>
